

































































import { Component, Vue, Ref, Watch } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import { auth } from "firebase/app";

import { updateEmailAddress } from "@/data/repository/ClientRepository";

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
  },
})
export default class ChangeEmailAndPasswordComponent extends Vue {
  isLoading = false;

  firstSignIn = true;

  oldPassword = "";
  newPassword = "";
  newPasswordRepeated = "";

  newEmailAddress = "";

  oldPasswordError: Array<string> = [];
  newPasswordError: Array<string> = [];
  newPasswordRepeatedError: Array<string> = [];

  newEmailAddressError: Array<string> = [];

  showOldPassword = false;
  showNewPassword = false;
  showNewPasswordRepeated = false;

  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  @Watch("newPassword")
  onNewPasswordChange() {
    this.newPasswordError = [];
  }

  @Watch("newPasswordRepeated")
  onNewPasswordRepeatedChange() {
    this.newPasswordRepeatedError = [];
  }

  resolve?: (value: boolean) => void = undefined;
  reject?: (reason: string) => void = undefined;

  async show(firstSignIn?: boolean) {
    this.firstSignIn = firstSignIn ?? false;

    this.newPassword = "";
    this.newPasswordRepeated = "";

    this.baseDialogComponent.show({
      title: this.$t(
        this.firstSignIn
          ? "changeEmailAndPassword.firstSignInTitle"
          : "changeEmailAndPassword.changeEmailAndPasswordTitle"
      ).toString(),
      positiveButtonText: this.$t("common.save").toString(),
      closeOnSave: false,
      persistent: true,
    });

    return new Promise<boolean>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  toggleShowOldPassword() {
    this.showOldPassword = !this.showOldPassword;
  }

  toggleShowNewPassword() {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleShowNewPasswordRepeated() {
    this.showNewPasswordRepeated = !this.showNewPasswordRepeated;
  }

  async onSetNewEmailAndPassword(
    oldEmail: string,
    oldPassword: string,
    newEmail: string,
    newPassword: string
  ) {
    this.isLoading = true;

    const authInstance = auth();

    try {
      const authResult = await authInstance.signInWithEmailAndPassword(
        oldEmail,
        oldPassword
      );

      const user = authResult.user;

      if (!user) {
        return;
      }

      try {
        await user.updateEmail(newEmail);
        await user.updatePassword(newPassword);
        await updateEmailAddress(newEmail);

        this.baseDialogComponent.isShowing = false;
        this.resolve && this.resolve(true);
      } catch (error) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((error as any).code === "auth/email-already-in-use") {
          this.newEmailAddressError = [
            this.$t(
              "changeEmailAndPassword.emailAddressAlreadyUsed"
            ).toString(),
          ];
        }
      }
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((error as any).code === "auth/wrong-password") {
        this.oldPasswordError = [
          this.$t("changeEmailAndPassword.passwordError").toString(),
        ];
      }
    }

    this.isLoading = false;
  }

  async onSave() {
    const oldPassword = this.oldPassword;
    const newPassword = this.newPassword;
    const newPasswordRepeated = this.newPasswordRepeated;

    if (newPassword.length < 8) {
      this.newPasswordError = [
        this.$t("resetPassword.errorMinPasswordLength").toString(),
      ];
      return;
    }

    if (newPassword != newPasswordRepeated) {
      this.newPasswordRepeatedError = [
        this.$t("resetPassword.errorPasswordNoMatch").toString(),
      ];
      return;
    }

    const oldEmailAddress = auth().currentUser?.email ?? "";

    await this.onSetNewEmailAndPassword(
      oldEmailAddress,
      oldPassword,
      this.newEmailAddress,
      newPassword
    );
  }
}
